import { makeStyles } from "@mui/styles";
import { createTheme } from "@mui/material/styles";
import BMWHelveticaBold from "../../fonts/BMWHelvetica-Bold/BMWHelvetica-Bold.otf";

export const mdTheme = createTheme({
  components: {
    MuiButton: {
      variants: [
        {
          props: { id: "pay" },
          style: {
            height: "33px",
            fontFamily: BMWHelveticaBold,
            fontStyles: "normal",
            fontWeight: 700,
            fontSize: "14px",
            lineHeight: "18px",
            width: "120px",
            background: "#39A2DB",
            borderRadius: "24px",
            color: "#fff",
            textTransform: "capitalize",
          },
        },
        {
          props: { variant: "accountManagement" },
          style: {
            fontSize: "14px",
            background: "#39A2DB",
            borderRadius: "24px",
            color: "#fff",
            textTransform: "capitalize",
            "&:hover": {
              background: "#226183",
            },
          },
        },
        // for configuration page
        {
          props: { className: "config-settings-btn" },
          style: {
            background: "#39A2DB",
            borderRadius: "24px",
            color: "#fff",
            textTransform: "capitalize",
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "18px",
            lineHeight: "22px",
            height: "36px",
            "&:hover": {
              background: "#226183",
            },
            "&:disabled": {
              background: "#D3D3D3",
              color: "#fff",
            }
          },
        },
        {
          props: { id: "add-card-btn" },
          style: {
            background: "#39A2DB",
            textTransform: "capitalize",
            borderRadius: "24px",
            fontSize: "13px",
            height: "32px",
            width: "130px",
          },
        },
        {
          props: { id: "add-bank-modal-btn" },
          style: {
            background: "#39A2DB",
            textTransform: "capitalize",
            borderRadius: "24px",
            fontSize: "14px",
            height: "32px",
            width: "130px",
          },
        },
        {
          props: { id: "add-bank-btn" },
          style: {
            background: "#39A2DB",
            textTransform: "capitalize",
            borderRadius: "24px",
            height: "32px",
            width: "130px",
            "&:disabled": {
              background: "#D3D3D3",
              color: "#fff",
            }
          },
        },
        {
          props: { id: "payMethod" },
          style: {
            background: "#39A2DB",
            borderRadius: "24px",
            height: "33px",
            textTransform: "none",
            fontWeight: 700,
            fontSize: "14px",
            lineHeight: "18px",
          },
        },
        {
          props: { id: "payMethodLink" },
          style: {
            textDecoration: "none",
          },
        },
        {
          props: { id: "recurring" },
          style: {
            background: "#39A2DB",
            borderRadius: "24px",
            textTransform: "none",
            fontWeight: 700,
            fontSize: "14px",
            lineHeight: "18px",
          },
        },
        {
          props: { id: "request-fund" },
          style: {
            borderRadius: "24px",
            textTransform: "capitalize",
          },
        },
        {
          props: { id: "done" },
          style: {
            borderRadius: "24px",
            textTransform: "capitalize",
          },
        },
        {
          props: { id: "print-download" },
          style: {
            fontFamily: "BMW Helvetica 75",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "14px",
            lineHeight: "18px",
            color: "#A2DBFA",
          },
        },
        {
          props: { id: "now" },
          style: {
            height: "41px",
            width: "334px",
            background: "#A2DBFA",
            borderRadius: "24px",
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "18px",
            lineHeight: "18px",
            textTransform: "capitalize",
          },
        },
        {
          props: { id: "future" },
          style: {
            height: "41px",
            width: "334px",
            background: "#39A2DB",
            borderRadius: "24px",
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "18px",
            lineHeight: "18px",
            textTransform: "capitalize",
          },
        },
        {
          props: { id: "recurringBtn" },
          style: {
            height: "41px",
            width: "334px",
            background: "#39A2DB",
            borderRadius: "24px",
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "18px",
            lineHeight: "18px",
            textTransform: "capitalize",
          },
        },
        {
          props: { id: "payment-modal-btn" },
          style: {
            height: "33px",
            background: "#39A2DB",
            borderRadius: "24px",
            fontFamily: "BMW Helvetica 75",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "14px",
            lineHeight: "18px",
            textTransform: "capitalize",
          },
        },
        {
          props: { id: "back-and-cancel-btn" },
          style: {
            height: "33px",
            borderRadius: "24px",
            fontFamily: "Work Sans",
            background: "none",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "18px",
            textTransform: "capitalize",
            marginLeft: "-15px",
          },
        },
      ],
    },
    MuiCard: {
      styleOverrides: {
        root: {
          background: "#FFFFFF",
          borderRadius: "24px",
        },
      },
    },
    MuiDialog: {
      styleOverrides: {
        root: {
          borderRadius: "24px",
        },
      },
      variants: [
        {
          props: { id: "payment-modal" },
          style: {
            textDecoration: "none",
            borderBottom: "none",
          },
        },
      ],
    },
    MuiModal: {
      styleOverrides: {
        root: {
          borderRadius: "24px",
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: "none",
        },
      },
      variants: [
        {
          props: { id: "navLink" },
          style: {
            textDecoration: "none",
            borderBottom: "none",
          },
        },
        {
          props: { id: "tableLink" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "18px",
            lineHeight: "18px",
            color: "#14142B",
            borderBottom: "none",
            textDecoration: "none",
          },
        },
      ],
    },
    MuiTypography: {
      variants: [
        {
          props: { id: "balance" },
          style: {
            // fontFamily: BMWHelveticaBold,
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "23px",
            color: "#14142B",
          },
        },
        {
          props: { id: "balanceAmount" },
          style: {
            width: "52px",
            height: "18px",
            Blend: "Pass through",
            fontWeight: 400,
            lineHeight: "18px",
            color: "#14142B",
            marginTop: "18px",
            marginBottom: "18px",
          },
        },
        {
          props: { id: "nextPayment" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "18px",
            lineHeight: "21px",
            color: "#000000",
            marginBottom: "18px",
          },
        },
        {
          props: { id: "nextPaymentDate" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "18px",
            lineHeight: "21px",
            color: "#14142B",
          },
        },
        {
          props: { id: "recurringTitle" },
          style: {
            fontFamily: "BMW Helvetica 75",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "23px",
            color: "#14142B",
            marginBottom: "17px",
          },
        },
        {
          props: { id: "nextDate" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "18px",
            lineHeight: "22px",
            color: "#14142B",
            marginBottom: "10px",
          },
        },
        {
          props: { id: "account" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "18px",
            lineHeight: "22px",
            color: "#14142B",
            marginBottom: "10px",
          },
        },
        {
          props: { id: "recurringAccount" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "18px",
            lineHeight: "18px",
            Blend: "Pass through",
            color: " #14142B",
            marginBottom: "15px",
          },
        },
        {
          props: { id: "recurringDate" },
          style: {
            Blend: "Pass through",
            color: " #14142B",
            marginBottom: "20px",
          },
        },
        {
          props: { id: "paymentMethodTitle" },
          style: {
            fontFamily: "'Open Sans', sans-serif",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "23px",
            color: "#14142B",
          },
        },
        {
          props: { id: "tableTitle" },
          style: {
            fontFamily: "'Open Sans', sans-serif",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "23px",
            color: "#14142B",
            marginBottom: "25px",
          },
        },
        {
          props: { id: "tableTitle" },
          style: {
            fontFamily: "'Open Sans', sans-serif",
            fontStyle: "normal",
            fontWeight: "bold",
            fontSize: "18px",
            lineHeight: "23px",
            color: "#14142B",
            marginLeft: "20px",
            marginBottom: "25px",
          },
        },
        {
          props: { id: "subTitle" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "22px",
            color: "#14142B",
            borderBottom: "none",
          },
        },
        {
          props: { className: "content" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "18px",
            lineHeight: "18px",
            color: "#14142B",
            borderBottom: "none",
          },
        },
        {
          props: { id: "nick-name" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "13px",
            lineHeight: "21px",
            color: "#000000",
            marginLeft: "8px",
            marginBottom: "15px",
          },
        },
        {
          props: { id: "nick-name-master-card" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "13px",
            lineHeight: "21px",
            color: "#000000",
            marginLeft: "8px",
            marginTop: "40px",
            marginBottom: "15px",
          },
        },
        {
          props: { id: "card-name" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "14px",
            color: "#14142B",
            opacity: 0.5,
            marginLeft: "8px",
          },
        },
        {
          props: { id: "card-number" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "13px",
            lineHeight: "21px",
            color: "#14142B",
            marginLeft: "8px",
          },
        },
        {
          props: { id: "nick-name-bank" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "13px",
            lineHeight: "21px",
            color: "#000000",
            marginLeft: "8px",
            marginBottom: "35px",
          },
        },
        {
          props: { id: "cardDates" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "11px",
            lineHeight: "18px",
            color: "#14142B",
            textAlign: "right",
            marginLeft: "51px",
            marginRight: "6px",
          },
        },
        {
          props: { id: "payment-details-title" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "22px",
            color: "#14142B",
            marginTop: "10px",
            textAlign: "center",
          },
        },
        {
          props: { id: "payment-id" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "18px",
            lineHeight: "34px",
            color: "#222222",
            marginBottom: "5px",
            textAlign: "center",
          },
        },
        {
          props: { id: "payment-details-date" },
          style: {
            fontFamily: "Open Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "17px",
            color: "#999999",
            marginBottom: "33px",
            textAlign: "center",
          },
        },
        {
          props: { id: "mainTitle" },
          style: {
            color: "#14142B",
            fontWeight: 700,
            fontSize: "20px",
          },
        },
        {
          props: { id: "paymentsBtn" },
          style: {
            fontFamily: "BMW Helvetica 75",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "18px",
            marginTop: "26px",
            marginBottom: "26px",
            color: "#14142B",
          },
        },
        {
          props: { id: "pay-modal-current-balance" },
          style: {
            fontFamily: "BMW Helvetica 75",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "15px",
            lineHeight: "23px",
            color: "#14142B",
            marginTop: "17px",
          },
        },
        {
          props: { id: "pay-modal-current-amount" },
          style: {
            fontFamily: "BMW Helvetica 75",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "18px",
            color: "#14142B",
            marginLeft: "50px",
            marginTop: "17px",
          },
        },
        {
          props: { id: "pay-modal-total-payment-text" },
          style: {
            fontFamily: "BMW Helvetica 75",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "15px",
            lineHeight: "22px",
            color: "#14142B",
            marginLeft: "100px",
            marginTop: "17px",
            marginBottom: "10px",
            textAlign: "right",
          },
        },
        {
          props: { id: "payment-modal-amount" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "18px",
            lineHeight: "18px",
            color: "#14142B",
            marginLeft: "53px",
            textAlign: "right",
          },
        },
        {
          props: { id: "payment-modal-sub-amount" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "18px",
            lineHeight: "22px",
            color: "#14142B",
          },
        },
        {
          props: { id: "payment-modal-details-main-text" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "22px",
            color: "#D3D3D3",
            textAlign: "right",
            marginBottom: "10px",
          },
        },
        {
          props: { id: "payment-modal-details-sub-text" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "22px",
            color: "#D3D3D3",
            textAlign: "right",
          },
        },
        {
          props: { id: "payment-modal-details-sub-value" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "22px",
            color: "#D3D3D3",
            marginLeft: "10px",
          },
        },
        {
          props: { id: "card-fee" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "13px",
            lineHeight: "18px",
            color: "#000000",
            textAlign: "center",
            marginTop: "10px",
            marginBottom: "15px",
          },
        },
        {
          props: { id: "paymentSummaryTitleText" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "18px",
            lineHeight: "18px",
            color: "#14142B",
            textAlign: "center",
          },
        },
        {
          props: { id: "review-submit" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "22px",
            color: "#14142B",
            textAlign: "center",
            marginTop: "14px",
            marginBottom: "20px",
          },
        },
        {
          props: { id: "review-submit-main-details" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: "22px",
            color: "#14142B",
          },
        },
        {
          props: { id: "review-submit-sub-details" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: "22px",
            color: "#D3D3D3",
          },
        },
        {
          props: { id: "review-submit-bank-details-text" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "16px",
            lineHeight: "22px",
            color: "#D3D3D3",
            marginTop: "18px",
          },
        },
        {
          props: { id: "review-submit-sub-bank-details" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "22px",
            color: "#39A2DB",
            marginTop: "18px",
          },
        },
        {
          props: { id: "review-submit-sub-bank-details-color-grey" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "22px",
            color: "#D3D3D3",
             marginTop: "18px",
          },
        },
        {
          props: { id: "legalese" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "16px",
            lineHeight: "18px",
            color: "#14142B",
            marginBottom: "12px",
            marginTop: "22px",
          },
        },
        {
          props: { id: "terms-and-condition" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "18px",
            color: "#14142B",
          },
        },
        {
          props: { id: "accept-payment" },
          style: {
            height: "33px",
            borderRadius: "24px",
            fontFamily: "Work Sans",
            background: "none",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "12px",
            lineHeight: "10px",
            marginTop: "12px",
            textTransform: "capitalize",
          },
        },
      ],
    },

    MuiTableCell: {
      variants: [
        {
          props: { id: "subTitle" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "22px",
            color: "#14142B",
          },
        },
        {
          props: { id: "content" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "18px",
            lineHeight: "18px",
            color: "#14142B",
          },
        },
        {
          props: { id: "tableLink" },
          style: {
            fontFamily: "Work Sans",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "18px",
            lineHeight: "18px",
            color: "#14142B",
            textDecoration: "none",
          },
        },
      ],
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          color: "#D3D3D3",
          "&.Mui-checked": {
            color: "#39A2DB",
          },
          "&.Mui-checked+.MuiSwitch-track": {
            backgroundColor: "#A2DBFA",
            opacity: 1
          },
        },
        track: {
          backgroundColor: "#F1F0F5",
          opacity: 1
        }
      }
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: "#D3D3D3",
          "&.Mui-checked": {
            color: "#39A2DB",
          },
          "&.Mui-checked+.MuiSwitch-track": {
            backgroundColor: "#A2DBFA",
            opacity: 1
          },
          "&.Mui-disabled": {
            color: "rgba(0, 0, 0, 0.26)",
          },
        },
      }
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "#D3D3D3",
          "&.Mui-checked": {
            color: "#39A2DB",
          },
          "&.Mui-checked+.MuiSwitch-track": {
            backgroundColor: "#A2DBFA",
            opacity: 1
          },
          "&.Mui-disabled": {
            color: "rgba(0, 0, 0, 0.26)",
          },
        },
      }
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          "&::-webkit-scrollbar": {
            width: 7,
          },
          "&::-webkit-scrollbar-track": {
            boxShadow: `inset 0 0 6px rgba(0, 0, 0, 0.3)`,
            borderRadius: '24px',
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "darkgrey",
            borderRadius: '24px',
          }
        },
      },
    }
  }
});

export const pmUIStyles = makeStyles({
  title: {
    color: "#14142B",
  },
  accountIcon: {
    background: "#FFFFFF",
    borderRadius: "24px",
    height: "49px",
    width: "174px",
    display: "flex",
    color: "#14142B",
    justifyContent: "space-between",
    alignItems: "center",
  },
  accountName: {
    fontFamily: "BMW Helvetica 75",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "1px",
    lineHeight: "22px",
    margin: "5px",
    height: "100%",
    width: "100%",
  },
  otherName: {
    fontFamily: "BMW Helvetica 75",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "10px",
    lineHeight: "22px",
    margin: "5px",
  },
  LogoContainer: {
    width: "100px",
    height: "74px",
    display: "flex",
    color: "#14142B",
    left: 0,
    justifyContent: "center",
    alignItems: "center",
    marginTop: "9px",
    // marginBottom: "103px",
  },
  logoName: {
    fontFamily: "BMW Helvetica 75",
    fontStyle: "normal",
    fontWeight: 700,
    fontSize: "18px",
    lineHeight: "22px",
    color: "#14142B",
  },
  menuContainer: {
    display: "flex",
    flexDirection: "column",
    color: "#14142B",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%",
  },
  listItem: {
    fontFamily: "Work Sans",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "22px",
    color: "#14142B",
    textDecoration: "none",
  },
  activeListItem: {
    fontFamily: "Work Sans",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "25px",
    lineHeight: "22px",
    color: "#14142B",
    textDecoration: "none",
  },
});
